/**
 * Uzbek interface texts. Written once in Latin script; Cyrillic is produced by
 * transliteration (with a few loanword exceptions). Placeholders: {name}.
 */

const L = {
	/* ---------- general ---------- */
	'app.tagline': 'Har qanday masofada — davra suhbati',
	'common.cancel': 'Bekor qilish',
	'common.close': 'Yopish',
	'common.save': 'Saqlash',
	'common.done': 'Tayyor',
	'common.copy': 'Nusxalash',
	'common.copied': 'Nusxalandi',
	'common.send': 'Yuborish',
	'common.yes': 'Ha',
	'common.ok': 'Yaxshi',
	'common.untitled': 'Nomsiz uchrashuv',
	'lang.label': 'Alifbo',

	/* ---------- home page ---------- */
	'home.title': 'Video uchrashuvlar — oddiy, tez va xavfsiz',
	'home.subtitle': 'Bir bosishda uchrashuv yarating, havolani yuboring va gaplashing. Ro\'yxatdan o\'tish shart emas.',
	'home.new': 'Yangi uchrashuv',
	'home.newOptions': 'Sozlamalar bilan',
	'home.joinPh': 'Kod yoki havola: abc-defg-hij',
	'home.join': 'Qo\'shilish',
	'home.or': 'yoki',
	'home.optTitle': 'Uchrashuv nomi (ixtiyoriy)',
	'home.optTitlePh': 'Masalan: Haftalik yig\'ilish',
	'home.optPass': 'Parol (ixtiyoriy)',
	'home.optWaiting': 'Kutish zali — qatnashchilarni o\'zim kiritaman',
	'home.optMute': 'Qatnashchilar mikrofoni o\'chiq holda kirsin',
	'home.optDuration': 'Davomiyligi',
	'home.noLimit': 'Cheklanmagan',
	'home.minutes': '{n} daqiqa',
	'home.hours': '{n} soat',
	'home.custom': 'Boshqa…',
	'home.customPh': 'Daqiqalar soni, masalan 25',
	'home.durationHint': 'Vaqt tugashi bilan uchrashuv hamma uchun avtomatik yakunlanadi.',
	'home.create': 'Uchrashuv yaratish',
	'home.creating': 'Yaratilmoqda…',
	'home.ready': 'Uchrashuv tayyor',
	'home.readyText': 'Havolani qatnashchilarga yuboring. Siz bu uchrashuvning mezbonisiz.',
	'home.start': 'Uchrashuvni boshlash',
	'home.mine': 'Mening uchrashuvlarim',
	'home.mineEmpty': 'Siz yaratgan uchrashuvlar shu yerda saqlanadi — keyin bir bosishda qayta ochasiz.',
	'home.forget': 'Ro\'yxatdan olib tashlash',
	'home.badCode': 'Kod noto\'g\'ri. U 10 ta harfdan iborat, masalan: abc-defg-hij',
	'home.error': 'Xatolik yuz berdi. Qaytadan urinib ko\'ring.',
	'home.f1t': 'Hammasi brauzerda',
	'home.f1': 'Dastur o\'rnatish shart emas — kompyuter va telefonda ishlaydi.',
	'home.f2t': 'Ekran, doska, so\'rovnoma',
	'home.f2': 'Ekran ulashish, birgalikdagi doska, so\'rovnomalar va kichik xonalar.',
	'home.f3t': 'Sizning serveringizda',
	'home.f3': 'Video va ovoz begona kompaniyalar orqali o\'tmaydi.',
	'home.footer': 'Ochiq manbali texnologiyalar asosida',
	'home.api': 'Dasturchilar uchun ⟦API⟧',

	/* ---------- pre-join ---------- */
	'pre.ready': 'Qo\'shilishga tayyormisiz?',
	'pre.name': 'Ismingiz',
	'pre.namePh': 'Masalan: Aziz Rahimov',
	'pre.passcode': 'Uchrashuv paroli',
	'pre.join': 'Qo\'shilish',
	'pre.joining': 'Ulanmoqda…',
	'pre.camOff': 'Kamera o\'chiq',
	'pre.inMeeting': 'Hozir uchrashuvda: {n} kishi',
	'pre.nobody': 'Hozircha hech kim yo\'q',
	'pre.duration': 'Davomiyligi: {n} daqiqa',
	'pre.timeLeft': 'Qolgan vaqt: {n} daqiqa',
	'pre.asHost': 'Siz bu uchrashuvning mezbonisiz',
	'pre.tip': 'Aks-sado bo\'lmasligi uchun quloqchin taqing.',
	'pre.mic': 'Mikrofon',
	'pre.cam': 'Kamera',
	'pre.speaker': 'Karnay',
	'pre.checking': 'Uchrashuv tekshirilmoqda…',

	/* ---------- waiting room ---------- */
	'wait.title': 'Kutish zalidasiz',
	'wait.text': 'Mezbon sizni tez orada uchrashuvga kiritadi. Iltimos, sahifani yopmang.',
	'wait.leave': 'Chiqish',

	/* ---------- errors ---------- */
	'err.not_found': 'Bunday uchrashuv mavjud emas yoki o\'chirilgan.',
	'err.time_over': 'Bu uchrashuvning vaqti tugagan. Yangi havola so\'rang.',
	'err.time_over_host': 'Bu uchrashuvning vaqti tugagan. Mezbon sifatida uni yangidan boshlashingiz mumkin.',
	'err.no_limit': 'Bu uchrashuvda vaqt cheklovi yo\'q.',
	'err.time_locked': 'Vaqtni o\'zgartirib bo\'lmaydi — u tashqi tizim tomonidan belgilangan.',
	'err.passcode_required': 'Bu uchrashuvga kirish uchun parol kerak.',
	'err.passcode_wrong': 'Parol noto\'g\'ri.',
	'err.locked': 'Uchrashuv qulflangan — hozir yangi qatnashchilar kira olmaydi.',
	'err.removed': 'Siz bu uchrashuvdan chiqarib yuborilgansiz.',
	'err.full': 'Uchrashuvda bo\'sh joy qolmagan.',
	'err.ended': 'Uchrashuv tugagan.',
	'err.link_expired': 'Havolaning muddati tugagan. Yangi havola so\'rang.',
	'err.bad_link': 'Havola noto\'g\'ri.',
	'err.bad_client': 'Brauzer ma\'lumotlari noto\'g\'ri. Sahifani yangilang.',
	'err.name_required': 'Ismingizni kiriting.',
	'err.rate_limited': 'Juda ko\'p urinish. Birozdan so\'ng qayta urinib ko\'ring.',
	'err.not_allowed': 'Mezbon bunga ruxsat bermagan.',
	'err.share_not_allowed': 'Mezbon ekran ulashishga ruxsat bermagan.',
	'err.already_sharing': '{name} hozir ekranini ulashmoqda.',
	'err.chat_off': 'Mezbon chatni o\'chirib qo\'ygan.',
	'err.private_off': 'Shaxsiy xabarlar o\'chirilgan.',
	'err.too_fast': 'Juda tez yozyapsiz — biroz kuting.',
	'err.record_off': 'Mezbon yozib olishga ruxsat bermagan.',
	'err.board_locked': 'Doskaga hozir faqat mezbonlar yoza oladi.',
	'err.host_only': 'Buni faqat mezbon qila oladi.',
	'err.left': 'Bu ishtirokchi uchrashuvdan chiqib ketgan.',
	'err.file_missing': 'Fayl topilmadi.',
	'err.poll_invalid': 'Savol va kamida ikkita variant yozing.',
	'err.poll_closed': 'So\'rovnoma yakunlangan.',
	'err.connection': 'Serverga ulanib bo\'lmadi. Internet aloqasini tekshiring.',
	'err.unsupported': 'Bu brauzer video aloqani qo\'llab-quvvatlamaydi. ⟦Chrome⟧, ⟦Edge⟧, ⟦Firefox⟧ yoki ⟦Safari⟧ning yangi versiyasidan foydalaning.',
	'err.insecure': 'Kamera va mikrofon faqat xavfsiz (https://) ulanishda ishlaydi.',
	'err.mediaBlocked': 'Brauzer {what}ga ruxsat bermadi. Manzil satridagi qulf belgisini bosib, ruxsat bering.',
	'err.mediaNotFound': '{what} topilmadi.',
	'err.mediaBusy': '{what} boshqa dastur tomonidan band.',
	'err.mediaOther': '{what}ni yoqib bo\'lmadi.',
	'err.generic': 'Xatolik: {msg}',
	'what.mic': 'Mikrofon',
	'what.cam': 'Kamera',
	'what.screen': 'Ekran',

	/* ---------- controls ---------- */
	'ctl.micOn': 'Mikrofonni o\'chirish',
	'ctl.micOff': 'Mikrofonni yoqish',
	'ctl.camOn': 'Kamerani o\'chirish',
	'ctl.camOff': 'Kamerani yoqish',
	'ctl.share': 'Ekranni ulashish',
	'ctl.stopShare': 'Ulashishni to\'xtatish',
	'ctl.react': 'Reaksiya',
	'ctl.hand': 'Qo\'l ko\'tarish',
	'ctl.handDown': 'Qo\'lni tushirish',
	'ctl.people': 'Ishtirokchilar',
	'ctl.chat': 'Chat',
	'ctl.board': 'Doska',
	'ctl.boardClose': 'Doskani yopish',
	'ctl.polls': 'So\'rovnomalar',
	'ctl.rooms': 'Kichik xonalar',
	'ctl.more': 'Yana',
	'ctl.leave': 'Chiqish',
	'ctl.record': 'Yozib olish',
	'ctl.stopRecord': 'Yozishni to\'xtatish',
	'ctl.speakerView': 'So\'zlovchi ko\'rinishi',
	'ctl.galleryView': 'Galereya ko\'rinishi',
	'ctl.pip': 'Kichik oyna',
	'ctl.fullscreen': 'To\'liq ekran',
	'ctl.exitFullscreen': 'To\'liq ekrandan chiqish',
	'ctl.settings': 'Sozlamalar',
	'ctl.info': 'Uchrashuv ma\'lumotlari',
	'ctl.shortcuts': 'Tezkor tugmalar',
	'ctl.effects': 'Fon effektlari',
	'ctl.hideSelf': 'O\'zimni yashirish',
	'ctl.showSelf': 'O\'zimni ko\'rsatish',

	/* ---------- top bar ---------- */
	'top.people': '{n} ishtirokchi',
	'top.recording': 'Yozib olinmoqda',
	'top.locked': 'Qulflangan',
	'top.good': 'Aloqa: a\'lo',
	'top.ok': 'Aloqa: o\'rtacha',
	'top.poor': 'Aloqa: zaif',
	'top.copyLink': 'Havolani nusxalash',
	'top.left': '{t} qoldi',
	'top.elapsed': 'Uchrashuvdagi vaqtingiz',
	'top.timeLeftTip': 'Uchrashuv tugashiga qolgan vaqt',

	/* ---------- stage ---------- */
	'stage.alone': 'Hozircha faqat sizsiz',
	'stage.aloneText': 'Boshqalarni taklif qilish uchun havolani yuboring.',
	'stage.youShare': 'Siz ekraningizni ulashmoqdasiz',
	'stage.loadingShare': 'Ekran yuklanmoqda…',
	'tile.you': 'siz',
	'tile.screen': '{name} ekrani',
	'tile.pin': 'Mahkamlash (faqat siz uchun)',
	'tile.unpin': 'Mahkamlashni olib tashlash',
	'pager': '{a} / {b}',

	/* ---------- roles ---------- */
	'role.host': 'Mezbon',
	'role.cohost': 'Yordamchi mezbon',
	'role.participant': 'Ishtirokchi',

	/* ---------- people panel ---------- */
	'people.search': 'Ism bo\'yicha qidirish',
	'people.waiting': 'Kutish zalida ({n})',
	'people.admit': 'Kiritish',
	'people.admitAll': 'Hammasini kiritish',
	'people.deny': 'Rad etish',
	'people.inMeeting': 'Uchrashuvda ({n})',
	'people.muteAll': 'Hammaning ovozini o\'chirish',
	'people.lowerHands': 'Hamma qo\'llarni tushirish',
	'people.more': 'Yana {n} kishi — qidiruvdan foydalaning',
	'menu.mute': 'Ovozini o\'chirish',
	'menu.askUnmute': 'Mikrofonni yoqishni so\'rash',
	'menu.stopVideo': 'Kamerasini o\'chirish',
	'menu.stopShare': 'Ulashishni to\'xtatish',
	'menu.allowShare': 'Ekran ulashishga ruxsat berish',
	'menu.disallowShare': 'Ekran ulashish ruxsatini olish',
	'menu.spotlight': 'Hamma uchun asosiy ekranga chiqarish',
	'menu.unspotlight': 'Asosiy ekrandan olish',
	'menu.pin': 'Mahkamlash',
	'menu.unpin': 'Mahkamlashni olish',
	'menu.message': 'Shaxsiy xabar yozish',
	'menu.rename': 'Ismini o\'zgartirish',
	'menu.renameSelf': 'Ismimni o\'zgartirish',
	'menu.makeCohost': 'Yordamchi mezbon qilish',
	'menu.removeCohost': 'Yordamchi mezbonlikdan olish',
	'menu.makeHost': 'Mezbonlikni topshirish',
	'menu.lowerHand': 'Qo\'lini tushirish',
	'menu.remove': 'Uchrashuvdan chiqarish',
	'menu.moveTo': 'Boshqa xonaga ko\'chirish',
	'confirm.remove': '{name} uchrashuvdan chiqarilsinmi? U bu uchrashuvga qayta kira olmaydi.',
	'confirm.makeHost': '{name} mezbon bo\'lsinmi? Siz yordamchi mezbon bo\'lib qolasiz.',
	'prompt.rename': 'Yangi ism',

	/* ---------- chat ---------- */
	'chat.to': 'Kimga',
	'chat.everyone': 'Hammaga',
	'chat.ph': 'Xabar yozing…',
	'chat.phPrivate': '{name}ga shaxsiy xabar…',
	'chat.attach': 'Fayl biriktirish',
	'chat.emoji': '⟦Emoji⟧',
	'chat.empty': 'Hozircha xabarlar yo\'q. Birinchi bo\'lib yozing!',
	'chat.privateTo': 'shaxsiy: {name}ga',
	'chat.privateFrom': 'sizga shaxsiy',
	'chat.you': 'Siz',
	'chat.uploading': '{name} yuklanmoqda…',
	'chat.tooBig': 'Fayl juda katta (ko\'pi bilan {mb} ⟦MB⟧).',
	'chat.uploadFailed': 'Faylni yuklab bo\'lmadi.',
	'chat.off': 'Mezbon chatni o\'chirgan',
	'chat.roomChat': '{room} chati',

	/* ---------- polls ---------- */
	'polls.new': 'Yangi so\'rovnoma',
	'polls.question': 'Savol',
	'polls.questionPh': 'Masalan: Keyingi uchrashuv qachon bo\'lsin?',
	'polls.option': '{n}-variant',
	'polls.addOption': 'Variant qo\'shish',
	'polls.multi': 'Bir nechta javob tanlash mumkin',
	'polls.anonymous': 'Anonim — kim nimani tanlagani ko\'rinmaydi',
	'polls.launch': 'Boshlash',
	'polls.vote': 'Ovoz berish',
	'polls.voted': 'Ovozingiz qabul qilindi',
	'polls.change': 'Javobni o\'zgartirish',
	'polls.close': 'Yakunlash',
	'polls.reopen': 'Qayta ochish',
	'polls.share': 'Natijani hammaga ko\'rsatish',
	'polls.unshare': 'Natijani yashirish',
	'polls.delete': 'O\'chirish',
	'polls.closed': 'Yakunlangan',
	'polls.open': 'Ovoz berish davom etmoqda',
	'polls.votes': '{n} ta ovoz',
	'polls.empty': 'Hozircha so\'rovnoma yo\'q.',
	'polls.emptyHost': 'Savol bering — qatnashchilar bir bosishda javob beradi.',
	'polls.results': 'Natijalar mezbon ko\'rsatganda chiqadi.',
	'polls.newToast': 'Yangi so\'rovnoma: {q}',
	'polls.answer': 'Javob berish',

	/* ---------- breakout rooms ---------- */
	'rooms.intro': 'Ishtirokchilarni alohida xonalarga bo\'ling. Har bir xona faqat o\'zini ko\'radi va eshitadi.',
	'rooms.count': 'Xonalar soni',
	'rooms.mode': 'Qanday taqsimlash',
	'rooms.auto': 'Avtomatik (teng va tasodifiy)',
	'rooms.manual': 'O\'zim taqsimlayman',
	'rooms.minutes': 'Vaqt chegarasi, daqiqa (0 — cheklovsiz)',
	'rooms.open': 'Xonalarni ochish',
	'rooms.openNow': 'Xonalar ochiq',
	'rooms.main': 'Asosiy zal',
	'rooms.room': '{n}-xona',
	'rooms.join': 'Kirish',
	'rooms.back': 'Qaytish',
	'rooms.here': 'Siz shu yerdasiz',
	'rooms.empty': 'Bo\'sh',
	'rooms.announcePh': 'Barcha xonalarga xabar',
	'rooms.closeAll': 'Xonalarni yopish — hammani qaytarish',
	'rooms.confirmClose': 'Barcha xonalar yopilib, hamma asosiy zalga qaytsinmi?',
	'rooms.left': '{t} qoldi',
	'rooms.closing': 'yopilmoqda…',
	'rooms.youAreIn': 'Siz {room}dasiz',
	'rooms.with': '{names} bilan',
	'rooms.help': 'Mezbonni chaqirish',
	'rooms.helpSent': 'Yordam so\'raldi ✋',
	'rooms.visiting': 'Siz {room}dasiz (mehmon sifatida)',
	'rooms.backMain': 'Asosiy zalga qaytish',
	'rooms.movedTo': 'Siz {room}ga o\'tkazildingiz. Endi sizni faqat shu xonadagilar ko\'radi va eshitadi.',
	'rooms.backAll': 'Siz asosiy zalga qaytdingiz.',
	'rooms.opened': 'Mezbon kichik xonalarni ochdi.',
	'rooms.ending': '{s} soniyadan so\'ng xonalar yopiladi va hamma asosiy zalga qaytadi.',
	'rooms.askHelp': '✋ {name} ({room}) yordam so\'ramoqda',
	'rooms.goHelp': '{room}ga kirish',
	'rooms.noPeople': 'Uchrashuvda hali qatnashchilar yo\'q.',

	/* ---------- whiteboard ---------- */
	'board.pen': 'Qalam',
	'board.marker': 'Marker',
	'board.line': 'Chiziq',
	'board.arrow': 'Strelka',
	'board.rect': 'To\'rtburchak',
	'board.ellipse': 'Doira',
	'board.text': 'Matn',
	'board.eraser': 'O\'chirg\'ich',
	'board.undo': 'Ortga qaytarish',
	'board.clear': 'Sahifani tozalash',
	'board.confirmClear': 'Bu sahifadagi hamma narsa o\'chirilsinmi?',
	'board.save': 'Rasm sifatida saqlash',
	'board.page': '{a} / {b}',
	'board.prev': 'Oldingi sahifa',
	'board.next': 'Keyingi sahifa',
	'board.newPage': 'Yangi sahifa',
	'board.textPh': 'Yozing va ⟦Enter⟧ni bosing',
	'board.opened': '{name} doskani ochdi',
	'board.readonly': 'Doskaga faqat mezbonlar yozadi',

	/* ---------- recording ---------- */
	'rec.started': 'Yozib olish boshlandi. Fayl faqat sizning qurilmangizga saqlanadi.',
	'rec.saved': 'Yozuv qurilmangizga saqlandi: {name}',
	'rec.unsupported': 'Bu brauzer yozib olishni qo\'llab-quvvatlamaydi.',
	'rec.someone': '{name} uchrashuvni yozib olmoqda',
	'rec.byHost': 'Mezbon yozib olishni o\'chirdi — yozuv saqlandi.',

	/* ---------- background effects ---------- */
	'fx.none': 'Effektsiz',
	'fx.blurLight': 'Yengil xiralik',
	'fx.blurStrong': 'Kuchli xiralik',
	'fx.upload': 'O\'z rasmingiz',
	'fx.loading': 'Effekt yuklanmoqda…',
	'fx.failed': 'Fon effekti ishlamadi.',
	'fx.needCam': 'Avval kamerani yoqing.',

	/* ---------- settings ---------- */
	'set.devices': 'Qurilmalar',
	'set.noise': 'Shovqinni pasaytirish',
	'set.mirror': 'O\'z videomni ko\'zgudek ko\'rsatish',
	'set.hideSelf': 'O\'z videomni ekranda yashirish',
	'set.language': 'Alifbo',
	'set.myName': 'Mening ismim',
	'set.meeting': 'Uchrashuv qoidalari',
	'set.meetingTitle': 'Uchrashuv nomi',
	'set.waitingRoom': 'Kutish zali — yangi qatnashchilarni mezbon kiritadi',
	'set.locked': 'Uchrashuvni qulflash — hech kim kira olmaydi',
	'set.allowUnmute': 'Qatnashchilar mikrofonini yoqa oladi',
	'set.allowVideo': 'Qatnashchilar kamerasini yoqa oladi',
	'set.allowShare': 'Qatnashchilar ekran ulasha oladi',
	'set.allowChat': 'Chat yoqilgan',
	'set.allowPrivateChat': 'Shaxsiy xabarlar yoqilgan',
	'set.allowRename': 'Qatnashchilar ismini o\'zgartira oladi',
	'set.allowReactions': 'Reaksiyalar yoqilgan',
	'set.allowRecording': 'Qatnashchilar uchrashuvni yozib ola oladi',
	'set.boardEveryone': 'Hamma doskaga chiza oladi',
	'set.muteOnEntry': 'Qatnashchilar mikrofoni o\'chiq holda kiradi',
	'set.tabMe': 'Men',
	'set.tabMeeting': 'Uchrashuv',

	/* ---------- info ---------- */
	'info.link': 'Havola',
	'info.code': 'Kod',
	'info.passcode': 'Parol',
	'info.copyInvite': 'Taklifnomani nusxalash',
	'info.invite': '{app}: "{title}" uchrashuviga taklif\nHavola: {url}\nKod: {code}',
	'info.invitePass': 'Parol: {pass}',
	'info.duration': 'Davomiyligi',

	/* ---------- leave ---------- */
	'leave.title': 'Uchrashuvdan chiqasizmi?',
	'leave.text': 'Havola orqali istalgan vaqtda qayta kirishingiz mumkin.',
	'leave.hostText': 'Siz mezbonsiz. Chiqib ketsangiz, mezbonlik boshqa ishtirokchiga o\'tadi.',
	'leave.assign': 'Yangi mezbon',
	'leave.auto': 'Avtomatik tanlansin',
	'leave.leave': 'Chiqish',
	'leave.end': 'Hamma uchun tugatish',

	/* ---------- end screens ---------- */
	'time.warn': 'Uchrashuv tugashiga {n} daqiqa qoldi',
	'time.warn1': 'Uchrashuv 1 daqiqadan keyin avtomatik yakunlanadi',
	'time.extend': 'Vaqtni uzaytirish',
	'time.extendBy': '+{n} daqiqa',
	'time.removeLimit': 'Vaqt cheklovini olib tashlash',
	'time.endsAt': 'Uchrashuv {time} da tugaydi',
	'time.extended': '{name} vaqtni {n} daqiqaga uzaytirdi',
	'time.removed': '{name} vaqt cheklovini olib tashladi',
	'time.locked': 'Vaqtni o\'zgartirib bo\'lmaydi',
	'time.restart': 'Yangidan boshlash',
	'end.left': 'Siz uchrashuvdan chiqdingiz',
	'end.thanks': 'Qatnashganingiz uchun rahmat!',
	'end.ended': 'Uchrashuv tugadi',
	'end.endedText': 'Mezbon uchrashuvni yakunladi.',
	'end.timeUp': 'Uchrashuv vaqti tugadi',
	'end.timeUpText': 'Belgilangan vaqt tugagani uchun uchrashuv hamma uchun yakunlandi.',
	'end.kicked': 'Sizni uchrashuvdan chiqarishdi',
	'end.replaced': 'Uchrashuv boshqa oynada ochildi',
	'end.replacedText': 'Siz bu uchrashuvga boshqa oyna yoki qurilmadan kirdingiz.',
	'end.lost': 'Aloqa uzildi',
	'end.lostText': 'Qayta ulanib bo\'lmadi. Internetni tekshirib, qaytadan kiring.',
	'end.denied': 'Mezbon sizni kiritmadi',
	'end.cantJoin': 'Uchrashuvga kirib bo\'lmadi',
	'end.rejoin': 'Qayta qo\'shilish',
	'end.home': 'Bosh sahifa',

	/* ---------- toasts ---------- */
	'toast.joined': '{name} qo\'shildi',
	'toast.left': '{name} chiqib ketdi',
	'toast.hand': '✋ {name} qo\'l ko\'tardi',
	'toast.waiting': '{name} kutish zalida',
	'toast.admit': 'Kiritish',
	'toast.muted': 'Mikrofoningiz o\'chirildi',
	'toast.camStopped': 'Kamerangiz o\'chirildi',
	'toast.shareStopped': 'Ekran ulashish to\'xtatildi',
	'toast.askUnmute': '{by} mikrofoningizni yoqishingizni so\'ramoqda',
	'toast.unmute': 'Yoqish',
	'toast.nowHost': 'Siz endi mezbonsiz',
	'toast.nowCohost': 'Siz yordamchi mezbon qilindingiz',
	'toast.noLongerCohost': 'Siz endi oddiy ishtirokchisiz',
	'toast.renamed': '{by} ismingizni "{name}" deb o\'zgartirdi',
	'toast.reconnecting': 'Aloqa uzildi — qayta ulanmoqda…',
	'toast.reconnected': 'Qayta ulandi',
	'toast.copied': 'Nusxalandi',
	'toast.startedShare': '{name} ekranini ulasha boshladi',
	'toast.allowedShare': 'Mezbon sizga ekran ulashishga ruxsat berdi',
	'toast.handRaised': 'Qo\'lingiz ko\'tarildi',
	'toast.audioBlocked': 'Brauzer ovozni to\'xtatdi',
	'toast.audioOn': 'Ovozni yoqish',
	'toast.message': '{name}: {text}',
	'toast.privateMessage': '{name} (shaxsiy): {text}',
	'toast.announcement': '📢 {name}: {text}',
	'toast.micLocked': 'Mezbon mikrofonlarni o\'chirib qo\'ygan. Gapirish uchun qo\'l ko\'taring.',
	'toast.camLocked': 'Mezbon qatnashchilar kamerasini o\'chirib qo\'ygan.',
	'toast.muteOnEntry': 'Uchrashuv qoidasiga ko\'ra mikrofoningiz o\'chiq holda kirdingiz.',
	'toast.spotlightYou': 'Siz hamma uchun asosiy ekranga chiqarildingiz',
	'toast.chatOff': 'Mezbon chatni o\'chirdi',
	'toast.chatOn': 'Mezbon chatni yoqdi',
	'toast.unmuteAllowed': 'Endi mikrofoningizni yoqishingiz mumkin',
	'toast.lockedOn': 'Uchrashuv qulflandi',
	'toast.lockedOff': 'Uchrashuv qulfdan chiqarildi',
	'toast.leftWaiting': '{name} kutishni to\'xtatdi',
	'toast.titleChanged': 'Uchrashuv nomi: {title}',

	/* ---------- shortcuts ---------- */
	'keys.mic': 'Mikrofonni yoqish / o\'chirish',
	'keys.cam': 'Kamerani yoqish / o\'chirish',
	'keys.share': 'Ekran ulashish',
	'keys.hand': 'Qo\'l ko\'tarish',
	'keys.chat': 'Chatni ochish',
	'keys.people': 'Ishtirokchilar ro\'yxati',
	'keys.layout': 'Ko\'rinishni almashtirish',
	'keys.fullscreen': 'To\'liq ekran',
	'keys.help': 'Shu oynani ochish'
};

// Loanwords that Uzbek Cyrillic spells differently from a letter-by-letter conversion.
const CYRL_EXCEPTIONS = [
	[/реаксия/g, 'реакция'], [/Реаксия/g, 'Реакция'],
	[/функсия/g, 'функция'], [/Функсия/g, 'Функция'],
	[/сессия/g, 'сессия'],
	[/Ютюб/g, 'YouTube']
];

const MAP = {
	a: 'а', b: 'б', c: 'с', d: 'д', e: 'е', f: 'ф', g: 'г', h: 'ҳ', i: 'и', j: 'ж', k: 'к', l: 'л', m: 'м',
	n: 'н', o: 'о', p: 'п', q: 'қ', r: 'р', s: 'с', t: 'т', u: 'у', v: 'в', w: 'в', x: 'х', y: 'й', z: 'з'
};
const isApos = (c) => c === '\'' || c === 'ʻ' || c === '’' || c === '‘' || c === 'ʼ' || c === '`';
const isLetter = (c) => !!c && /[A-Za-z]/.test(c);

function toCyrillicWord(s) {
	let out = '';
	for (let i = 0; i < s.length; i++) {
		const ch = s[i];
		const lower = ch.toLowerCase();
		const up = ch !== lower;
		const next = (s[i + 1] || '').toLowerCase();
		const cased = (c) => (up ? c.toUpperCase() : c);
		const wordStart = !isLetter(s[i - 1]) && !isApos(s[i - 1]);
		if ((lower === 'o' || lower === 'g') && isApos(s[i + 1])) { out += cased(lower === 'o' ? 'ў' : 'ғ'); i++; continue; }
		if (lower === 's' && next === 'h') { out += cased('ш'); i++; continue; }
		if (lower === 'c' && next === 'h') { out += cased('ч'); i++; continue; }
		if (lower === 'y' && next === 'o' && !isApos(s[i + 2])) { out += cased('ё'); i++; continue; }
		if (lower === 'y' && next === 'u') { out += cased('ю'); i++; continue; }
		if (lower === 'y' && next === 'a') { out += cased('я'); i++; continue; }
		if (lower === 'y' && next === 'e') { out += cased('е'); i++; continue; }
		if (lower === 'e' && wordStart) { out += cased('э'); continue; }
		if (isApos(ch) && isLetter(s[i - 1]) && isLetter(s[i + 1])) { out += 'ъ'; continue; }
		out += MAP[lower] ? cased(MAP[lower]) : ch;
	}
	return out;
}

/**
 * Latin → Cyrillic. Left unchanged: {placeholders}, URLs and ⟦brand names⟧
 * (the ⟦ ⟧ markers are removed in both scripts).
 */
export function toCyrillic(text) {
	let out = String(text)
		.split(/(\{[^}]*\}|https?:\/\/\S+|⟦[^⟧]*⟧)/)
		.map((part, i) => (i % 2 ? part : toCyrillicWord(part)))
		.join('');
	for (const [re, rep] of CYRL_EXCEPTIONS) out = out.replace(re, rep);
	return out;
}

const stripMarks = (s) => s.replace(/[⟦⟧]/g, '');

const SCRIPT_KEY = 'davra-script';
let script = 'latn';
try {
	script = localStorage.getItem(SCRIPT_KEY) || (/^uz-cyrl/i.test(navigator.language) ? 'cyrl' : 'latn');
} catch { /* private mode */ }

const cache = {};
let globals = { app: 'Davra' };

export function setGlobals(g) {
	globals = { ...globals, ...g };
}

export function getScript() {
	return script;
}

export function setScript(s) {
	script = s === 'cyrl' ? 'cyrl' : 'latn';
	try { localStorage.setItem(SCRIPT_KEY, script); } catch { /* ignore */ }
	document.documentElement.lang = script === 'cyrl' ? 'uz-Cyrl' : 'uz-Latn';
	applyI18n(document);
	document.dispatchEvent(new CustomEvent('scriptchange'));
}

export const hasKey = (key) => Object.prototype.hasOwnProperty.call(L, key);

/** Translate a key. Unknown keys are returned as-is (and reported in the console). */
export function t(key, vars = {}) {
	let text = L[key];
	if (text === undefined) {
		console.warn(`[i18n] missing key: ${key}`);
		text = key;
	}
	if (script === 'cyrl') {
		if (!cache[key]) cache[key] = stripMarks(toCyrillic(text));
		text = cache[key];
	} else {
		text = stripMarks(text);
	}
	const all = { ...globals, ...vars };
	return text.replace(/\{(\w+)\}/g, (m, k) => (all[k] !== undefined ? String(all[k]) : m));
}

/** Fill elements marked with data-i18n, data-i18n-title, data-i18n-placeholder, data-i18n-aria. */
export function applyI18n(root = document) {
	for (const el of root.querySelectorAll('[data-i18n]')) el.textContent = t(el.dataset.i18n);
	for (const el of root.querySelectorAll('[data-i18n-title]')) el.title = t(el.dataset.i18nTitle);
	for (const el of root.querySelectorAll('[data-i18n-placeholder]')) el.placeholder = t(el.dataset.i18nPlaceholder);
	for (const el of root.querySelectorAll('[data-i18n-aria]')) el.setAttribute('aria-label', t(el.dataset.i18nAria));
}

document.documentElement.lang = script === 'cyrl' ? 'uz-Cyrl' : 'uz-Latn';
